import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {
  CustomTheme,
  getSignatureUrlsByLoanIdWithParams,
  IntegrationType,
  LenderName,
  PaymentMethodType,
  SignatureUrls,
} from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { NextActionSignContractProps } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/NextActionSignContract';
import { SignatureFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/SignatureFactory';
import { SignatureMissingVehicleDataCaption } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/SignatureMissingVehicleDataCaption';
import { LoadingValuesWarning } from '@/components/modules/Documentation/components/shared/LoadingValuesWarning';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCache } from '@/hooks/requests/useCache';
import { useCustomTheme } from '@/hooks/useCustomTheme';

//const SIGNATURE_URLS: SignatureUrls = {
//  createdAt: new Date('2025-06-19T13:28:06+00:00'),
//  updatedAt: new Date('2025-06-19T13:28:06+00:00'),
//  id: '20eab40f-c925-4ffd-b0fe-89ea456fcc0a',
//  action: 'En breves recibirá un correo con las instrucciones para la firma del contrato. Muchas gracias',
//  integrationType: IntegrationType.EMBEDDED_SAML,
//  url: 'https://www.demo.logalty.es:443/lgt/lgtfrontend/login/samlLogin',
//  urlIne: null,
//  urlPrivacyPolicy: null,
//  saml: '%3Csamlp%3AResponse+xmlns%3Asamlp%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aprotocol%22+Consent%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aconsent%3Acurrent-explicit%22+Destination%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aconsent%3Acurrent-explicit%22+ID%3D%22samlBBVA1%22+IssueInstant%3D%222025-06-19T15%3A28%3A04.071%22+Version%3D%222.0%22+xmlns%3Asaml%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aassertion%22+xmlns%3Axsi%3D%22http%3A%2F%2Fwww.w3.org%2F2001%2FXMLSchema-instance%22%3E%3Cdsig%3ASignature+xmlns%3Adsig%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2F09%2Fxmldsig%23%22+Id%3D%22Id1786693455176226129372072697%22%3E%0A%3Cdsig%3ASignedInfo+Id%3D%22Id40105422510559719261012598650%22%3E%0A%3Cdsig%3ACanonicalizationMethod+Algorithm%3D%22http%3A%2F%2Fwww.w3.org%2F2001%2F10%2Fxml-exc-c14n%23%22%2F%3E%0A%3Cdsig%3ASignatureMethod+Algorithm%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2F09%2Fxmldsig%23rsa-sha1%22%2F%3E%0A%3Cdsig%3AReference+Id%3D%22Id9652383319450970841664370731%22+URI%3D%22%22%3E%0A%3Cdsig%3ATransforms%3E%0A%3Cdsig%3ATransform+Algorithm%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2F09%2Fxmldsig%23enveloped-signature%22%2F%3E%0A%3Cdsig%3ATransform+Algorithm%3D%22http%3A%2F%2Fwww.w3.org%2F2001%2F10%2Fxml-exc-c14n%23%22%2F%3E%0A%3C%2Fdsig%3ATransforms%3E%0A%3Cdsig%3ADigestMethod+Algorithm%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2F09%2Fxmldsig%23sha1%22%2F%3E%0A%3Cdsig%3ADigestValue%3EYARi19shQVypTMIc4yX3n%2BIQBNw%3D%3C%2Fdsig%3ADigestValue%3E%0A%3C%2Fdsig%3AReference%3E%0A%3C%2Fdsig%3ASignedInfo%3E%0A%3Cdsig%3ASignatureValue+Id%3D%22Id8605916156759822931232455440%22%3ENlSvyhT196AKSS6hCZOM6IybDdT8q9GLaNYL67ztHfcArYVhBr69b1Eha%2FqJ1X8a%2FEnM%2BB%2BzTdrGSsk7nuObT4EZzyLvIiz2dYZVEsBm8OEVAgiv64Uf5JdoqrzLJCOnFn9PtLeGL0znsAHK2JNKanpLEccfCeO9utQ3Jhdkry6hlcCaraaHoHCEQAoeuME58iLrSOrhH7JF57hK6c6UCgAV17%2FNTG1ItZiDNyhN6%2Bm%2FOcU%2F165mFZndhQrLjzOjLJyNWDXe7axEiT%2BfAfERLPm%2Fe9%2B%2B0FMH6ZA3NgtjucBR3fxh4Tg%2FrN4nJy8uzjUbqEJXWZNLbSy6LtmgHyE4IA%3D%3D%3C%2Fdsig%3ASignatureValue%3E%0A%3Cdsig%3AKeyInfo%3E%0A%3Cdsig%3AX509Data%3E%0A%3Cdsig%3AX509SubjectName%3ECN%3DBBVA-GDPR%2C+OU%3DDepartamento+de+Informatica%2C+O%3DBBVA%3C%2Fdsig%3AX509SubjectName%3E%0A%3C%2Fdsig%3AX509Data%3E%0A%3Cdsig%3AX509Data%3E%0A%3Cdsig%3AX509Certificate%3EMIIFOTCCBCGgAwIBAgITdQAAKiylx4WHFaTR7wABAAAqLDANBgkqhkiG9w0BAQsFADAsMQ0wCwYDVQQKEwRCQlZBMRswGQYDVQQDExJCQlZBIENBIFNlcnZpZG9yZXMwHhcNMjIwOTMwMDgzNjU3WhcNMjYwOTI5MDgzNjU3WjBJMQ0wCwYDVQQKEwRCQlZBMSQwIgYDVQQLExtEZXBhcnRhbWVudG8gZGUgSW5mb3JtYXRpY2ExEjAQBgNVBAMTCUJCVkEtR0RQUjCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBANHes7aOpG4y8bdtOPTvkxrorqROMlscrLQjgal1kB1Tw0rcQLdNg1LeKorhtzx3CmbyBcKJQPN64DxE6AhBcRyaU5IQuapd9p7Md7QSgEe%2FUObF%2BmxYBx892yUCgYtXepWzQnJkZg9KFAf0C8Pxv32N%2FSDq1MU0PTrBy08xXZMTQLz1cT80jZnMWfmHIgauHbaQWFebZDq15bFjKvLcZGZ5guEfjenxMy9VGi9Siams%2FgAtTr2B%2F3khq8jg4N2JfFYkfL3gTEGmAgA0IQx3PoHreatuHdhEma%2FTnnMsYBFz61bdYh8oO%2BkkTXYJu00NCEQYEF83YUjhrasx1c%2B67F8CAwEAAaOCAjUwggIxMB0GA1UdDgQWBBSGyXLwZ%2BbrVoSBbTr99MkR0LK3CDAfBgNVHSMEGDAWgBSchCa%2BO6zdDEEZ1SyQcnnbhLwx7jB5BgNVHR8EcjBwMG6gbKBqhjRodHRwOi8vY3JsLmlncnVwb2JidmEvY3JsL0JCVkElMjBDQSUyMFNlcnZpZG9yZXMuY3JshjJodHRwOi8vY3JsLmJidmEuY29tL2NybC9CQlZBJTIwQ0ElMjBTZXJ2aWRvcmVzLmNybDCB8gYIKwYBBQUHAQEEgeUwgeIwXAYIKwYBBQUHMAKGUGh0dHA6Ly9jcmwuaWdydXBvYmJ2YS9jcmwvVjExMjhQS0lQMDAyLmFkLmJidmEuY29tX0JCVkElMjBDQSUyMFNlcnZpZG9yZXMoMSkuY3J0MFoGCCsGAQUFBzAChk5odHRwOi8vY3JsLmJidmEuY29tL2NybC9WMTEyOFBLSVAwMDIuYWQuYmJ2YS5jb21fQkJWQSUyMENBJTIwU2Vydmlkb3JlcygxKS5jcnQwJgYIKwYBBQUHMAGGGmh0dHA6Ly9jcmwuaWdydXBvYmJ2YS9vY3NwMAsGA1UdDwQEAwIFoDA8BgkrBgEEAYI3FQcELzAtBiUrBgEEAYI3FQiDgshY1fNChbmdLIbM9n3upBGBNoLMshGCib8yAgFkAgEPMBUGA1UdJQQOMAwGCisGAQQBgjcKAwwwHQYJKwYBBAGCNxUKBBAwDjAMBgorBgEEAYI3CgMMMA0GCSqGSIb3DQEBCwUAA4IBAQBxLH2Se62LGDmw0KqcBjuyav6iPVliYGlNM7NhLFol4Yv%2FiHHTTWTiX6ejFB%2FLQpAhvOhEFTBuD0H%2BMz9Bxpsf3xSgGVshh89s%2FnD%2B1eE4967o4qzz988lQrVtZiLuFdThTYz1mrd6HnRD9YGSh04TSFAKHKH9AJGIqVDjRnnl183BGAEmJHyE9oK8T3LPB0YozpquOxWkelocV7Qp1DmmI9bM6UFBnwMIZvCxm%2BRXT4zmecjZP%2BP3izcgB5ipUii1oupoEM1LjN62tWHqD61DP9oqfqX0k%2FeSLuGhqC6OjUgrQRNV270K3oLX1ihzsqek9BMKgL%2BDfw50TELW4n1C%3C%2Fdsig%3AX509Certificate%3E%0A%3C%2Fdsig%3AX509Data%3E%0A%3C%2Fdsig%3AKeyInfo%3E%0A%3C%2Fdsig%3ASignature%3E%0A%3Csamlp%3AStatus%3E%0A%3Csamlp%3AStatusCode+Value%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Astatus%3ASuccess%22%2F%3E%0A%3C%2Fsamlp%3AStatus%3E%0A%3Csaml%3AAssertion+ID%3D%22samlBBVA2%22+IssueInstant%3D%222025-06-19T15%3A28%3A04.071%22+Version%3D%222.0%22%3E%0A%3Csaml%3AIssuer%3Ehttp%3A%2F%2Fwww.logalty.es%3C%2Fsaml%3AIssuer%3E%0A%3Csaml%3ASubject%3E%0A%3Csaml%3ANameID+Format%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Anameid-format%3Apersistent%22%2F%3E%0A%3Csaml%3ASubjectConfirmation+Method%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Acm%3Abearer%22%3E%0A%3Csaml%3ASubjectConfirmationData+NotOnOrAfter%3D%222030-06-18T15%3A28%3A04.071%22+Recipient%3D%22http%3A%2F%2Fwww.logalty.es%22%2F%3E%0A%3C%2Fsaml%3ASubjectConfirmation%3E%0A%3C%2Fsaml%3ASubject%3E%0A%3Csaml%3AConditions%3E%0A%3Csaml%3AAudienceRestriction%3E%0A%3Csaml%3AAudience%3EBBVA_FNET%3C%2Fsaml%3AAudience%3E%0A%3C%2Fsaml%3AAudienceRestriction%3E%0A%3C%2Fsaml%3AConditions%3E%0A%3Csaml%3AAuthnStatement+AuthnInstant%3D%222025-06-19T15%3A28%3A04.071%22%3E%0A%3Csaml%3AAuthnContextClassRef%3Eurn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aac%3Aclasses%3APasswordProtectedTransport%3C%2Fsaml%3AAuthnContextClassRef%3E%0A%3Csaml%3AAuthnContext%2F%3E%0A%3C%2Fsaml%3AAuthnStatement%3E%0A%3Csaml%3AAttributeStatement%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Alogin_type%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3ENODE%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Adocument_guid%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E001001-9996-000000000167997.par%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Abrowser_frames%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E0%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Adoc_frame_return%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E_self%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Aauto_redirect%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E1%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Aredirect_delay%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E0%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Aurl_back%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E%3C!%5BCDATA%5Bhttps%3A%2F%2Fcdn.nemuru.com%2Fassets%2Fhtml%2Fcallback%2Fsaml-redirect.html%5D%5D%3E%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3Csaml%3AAttribute+Name%3D%22urn%3Alogalty%3Aschemas%3Acore%3A1.0%3Aattributes%3Adoc_in_frame%22+NameFormat%3D%22urn%3Aoasis%3Anames%3Atc%3ASAML%3A2.0%3Aattrnameformat%3Abasic%22%3E%0A%3Csaml%3AAttributeValue%3E1%3C%2Fsaml%3AAttributeValue%3E%0A%3C%2Fsaml%3AAttribute%3E%0A%3C%2Fsaml%3AAttributeStatement%3E%0A%3C%2Fsaml%3AAssertion%3E%0A%3C%2Fsamlp%3AResponse%3E',
//  urlCookies: null,
//  urlCommunications: null,
//};

const LENDERS_ALLOWED_TO_DISABLE_SIGNATURE = [LenderName.CAIXABANK, LenderName.BBVA];

export const Signature = ({ paymentMethodDetailEntity }: NextActionSignContractProps) => {
  const { getTextIdTranslation } = useTranslation();
  const { width, ref } = useWidth<HTMLDivElement>();
  const { customBorderRadius } = useCustomTheme();
  const { themeName } = useCustomTheme();

  const loan = paymentMethodDetailEntity.loan!;

  const {
    data: signatureUrls,
    loading,
    revalidate,
  } = useCache(getSignatureUrlsByLoanIdWithParams, {
    loanId: loan.id,
    withUrls: true,
  });

  useEffect(() => {
    revalidate();
    // paymentMethodDetailEntity is cloned in every refresh (updatePaymentMethodEntity in usePaymentIntent)
  }, [loan.loanApplicationSelected?.contractRequiresResignature]);

  if (loading) {
    return <LoadingValuesWarning />;
  }

  if (!loan.loanApplicationSelected) {
    return null;
  }

  const showCustomMessageForCaixabank = shouldShowCustomMessageForCaixabank({
    paymentMethodDetailEntity,
    themeName,
  });

  if (!signatureUrls) {
    return (
      <Box width={'100%'}>
        <Alert severity="warning" style={{ borderRadius: customBorderRadius.paper }}>
          <Box>
            <Font variant="body2" display="block">
              <Text strong tId={'NO_SIGNATURE_AVAILABLE_TITLE'} />
            </Font>
            <Font variant="body2" display="block">
              <Text
                tId={'NO_SIGNATURE_PROCESS_AVAILABLE_AT_THE_MOMENT'}
                dynamicDataTexts={[getTextIdTranslation(loan.loanApplicationSelected.lenderName)]}
              />
            </Font>
          </Box>
        </Alert>
      </Box>
    );
  }

  const requiresResignature = !!loan.loanApplicationSelected?.contractRequiresResignature;
  const disableSignContractButton =
    LENDERS_ALLOWED_TO_DISABLE_SIGNATURE.includes(loan.loanApplicationSelected.lenderName) &&
    paymentMethodDetailEntity.isMissingVehicleRegistrationNumberOrLicensePlate();

  const signatureTitle = getSignatureTitle(paymentMethodDetailEntity);
  const signatureMessage = showCustomMessageForCaixabank
    ? 'SIGNATURE_FROM_CAIXABANK_APP_MESSAGE'
    : getSignatureMessage(signatureUrls, paymentMethodDetailEntity);

  const signatureAvailable = signatureUrls.integrationType
    ? [IntegrationType.EMBEDDED, IntegrationType.EMBEDDED_SAML, IntegrationType.REDIRECT].includes(
        signatureUrls.integrationType,
      )
    : false;

  return (
    <Box>
      <CustomPaper fill="grey.light">
        <div
          ref={ref}
          style={{
            display: 'flex',
            width: '100%',
            gridGap: 24,
            flexDirection: width && width > 600 ? 'row' : 'column',
          }}
        >
          <FlexColumn gridGap={4} flexGrow={1}>
            <Font variant="body2" color="textPrimary" display="block">
              <Text
                strong
                tId={signatureTitle}
                dynamicDataTexts={[getTextIdTranslation(loan.loanApplicationSelected.lenderName)]}
              />
            </Font>
            <Font variant="body2" color="textSecondary" display="block">
              <Text tId={signatureMessage} />
            </Font>
          </FlexColumn>
          {signatureAvailable && !showCustomMessageForCaixabank && (
            <Box flexShrink={0}>
              <SignatureFactory
                signatureUrls={signatureUrls}
                paymentMethodDetailEntity={paymentMethodDetailEntity}
                requiresResignature={requiresResignature}
                disabled={disableSignContractButton}
              />
            </Box>
          )}
        </div>
        <SignatureMissingVehicleDataCaption paymentMethodDetailEntity={paymentMethodDetailEntity} />
      </CustomPaper>
    </Box>
  );
};

const getSignatureTitle = (paymentMethodDetailEntity: LoanPaymentMethodDetailEntity) => {
  const lenderName = paymentMethodDetailEntity.loan?.loanApplicationSelected?.lenderName;
  if (lenderName === LenderName.SANTANDER_CONSUMER) {
    return 'SIGNATURE_LENDER_CONTRACT_SANTANDER';
  }
  return 'SIGNATURE_LENDER_CONTRACT';
};

const getSignatureMessage = (
  signatureUrls: SignatureUrls,
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity,
) => {
  if (paymentMethodDetailEntity.loan?.loanApplicationSelected?.contractRequiresResignature) {
    return 'RESIGNATURE_MESSAGE';
  }

  const lenderName = paymentMethodDetailEntity.loan?.loanApplicationSelected?.lenderName;

  switch (signatureUrls.integrationType) {
    case IntegrationType.REDIRECT:
    case IntegrationType.EMBEDDED:
      if (paymentMethodDetailEntity.isSignatureEmbeddable(IntegrationType.REDIRECT)) {
        return 'EMBEDDED_REDIRECT_SIGNATURE';
      }
      if (lenderName === LenderName.BS) {
        return 'REDIRECT_SIGNATURE_BS';
      }
      if (lenderName === LenderName.SANTANDER_CONSUMER) {
        return 'REDIRECT_SIGNATURE_SANTANDER';
      }
      return 'REDIRECT_SIGNATURE';
    case IntegrationType.EMBEDDED_SAML:
      return 'SAML_SIGNATURE';
    case IntegrationType.ASYNC:
      return 'ASYNC_SIGNATURE_EMAIL';
    default:
      return 'SIGNATURE_GENERIC_MESSAGE';
  }
};

const shouldShowCustomMessageForCaixabank = ({
  themeName,
  paymentMethodDetailEntity,
}: {
  themeName: string;
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}) => {
  const loanApplicationSelected = paymentMethodDetailEntity.loan?.loanApplicationSelected;
  if (!loanApplicationSelected) {
    return false;
  }

  const isCaixabankLender = loanApplicationSelected.lenderName === LenderName.CAIXABANK;
  const isAutoPaymentType = paymentMethodDetailEntity.type === PaymentMethodType.AUTO_LOAN;

  const isAllowedTheme = themeName !== CustomTheme.QUADIS && themeName !== CustomTheme.PROA_GROUP;

  return isCaixabankLender && isAutoPaymentType && isAllowedTheme;
};
